import moment from "moment";

export const FILTER_CACHE_KEY = 'analyticsFilter';
export const FILTER_CACHE_LIFETIME_MINUTES = 30;

export function getCookie(cookieName) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + cookieName + "=");
    if (parts.length == 2) {
        return parts.pop().split(";").shift();
    }
    return false;
}

export function setCookie(cookieName, value, exMinutes) {
    var d = new Date();
    d.setTime(d.getTime() + (exMinutes * 60 * 1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cookieName + "=" + value + ";" + expires + ";path=/";
}

export function getCachedFilter() {
    const cachedFilterJson = getCookie(FILTER_CACHE_KEY);
    if (!cachedFilterJson) {
        return false;
    }

    return JSON.parse(cachedFilterJson);
}

export function cacheFilterValues(filter, propertiesToCache) {
    const newFilter = {...filter};
    for (let p in newFilter) {
        if (newFilter.hasOwnProperty(p) && propertiesToCache.indexOf(p) === -1) {
            delete newFilter[p];
        }
    }

    if (newFilter) {
        newFilter.createdAt = moment().unix();
        setCookie(FILTER_CACHE_KEY, JSON.stringify(newFilter), FILTER_CACHE_LIFETIME_MINUTES);
    }
}


// WEBPACK FOOTER //
// ./web/src/components/analytics/analyticOptions.js